export const VehicleTypeEnum = {
    "0": "All Vehicles",
    "1": "Allow List Vehicles",
    "2": "General Vehicles",
}

export const DateGroupingTypeEnum = {
    "0": "Daily",
    "1": "Weekly",
    "2": "Monthly",
}

export const reportDatePresetByLabel = {
    "Today": 1,
    "Last month": 2,
    "This month": 3,
    "This quarter": 4,
    "Last quarter": 5,
    "This year": 6,
    "Last year": 7,
    "Year to date": 8,
    "Month to date": 9,
    "Quarter to date": 10,
}

export const reportsRoutingByEnum = {
    0: "/export-breaches",
    2: "/appeals", 
    3: "/transfer-of-liabilities", 
    4: "/pcns-issued", 
    5: "/debt-recovery", 
    6: "/pcns-paid", 
    8: "/cancellations", 
    9: "/voids", 
    11: "/average-stay",
    12: "/daily-totals",
    13: "/parking-durations",
    14: "/breaches", 
    15: "/contraventions",
    16: "/data-storage"
}